import { render, staticRenderFns } from "./MainQueueCard.vue?vue&type=template&id=0dc210c6&scoped=true&"
import script from "./MainQueueCard.vue?vue&type=script&lang=js&"
export * from "./MainQueueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc210c6",
  null
  
)

export default component.exports